import { useDerivedStateFromProps } from './use-derived-state-from-props.js'

export function useCheckedOnChange(propsChecked, onChange) {
    const [checked, setChecked] = useDerivedStateFromProps(propsChecked)

    const onInputChanged = event => {
        setChecked(!checked)
        onChange(event)
    }

    return [checked, onInputChanged]
}
